
import React, { useState, useEffect, useContext } from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import {
  useConnectModal,
  useAccountModal,
  useChainModal,
} from '@rainbow-me/rainbowkit';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from 'notistack';
import { Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useAccount, useChainId, useSwitchChain } from 'wagmi'; // Updated hooks
import 'react-tabs/style/react-tabs.css';
import ethereumLogo from '../assets/images/coin/eth.png';
import bscLogo from '../assets/images/coin/bnb.png';
import baseLogo from '../assets/images/coin/base-logo.png';
import avalancheLogo from '../assets/images/coin/avalanche-logo.png';
import solanaLogo from '../assets/images/coin/solana-logo.png';
import { TokenContext } from '../contexts/ValutsContext';
import Typography from '@mui/material/Typography';

import Swap from '../components/swap/index';
import ClaimForm from '../components/swap/ClaimForm';



const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

const Vaults = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { openConnectModal } = useConnectModal();
  const { tokens, setNetworkTokens, networkList } = useContext(TokenContext);
  const [selectedToken, setSelectedToken] = useState({});
  const [isSwapDialogOpen, setIsSwapDialogOpen] = useState(false);
  const [isGraveYardsLoading, setIsGraveYardsLoading] = useState(true);
  const { openChainModal } = useChainModal();
  // Use hooks to get account and chain info
  const { address } = useAccount();
  const chainId = useChainId(); // Use useChainId instead of useNetwork
  const { chains, isLoading, pendingChainId, switchChain } = useSwitchChain(); // Use useSwitchChain

  const handleSwitchNetwork = async (chainId) => {
    if (address) {
      if (switchChain) {
        try {
          openChainModal();
        } catch (error) {
          console.error('Error while trying to switch network:', error);
        }
      } else {
        console.error('switchChain is not available.');
      }
    } else {
      openConnectModal();
    }

  };



  const fetchData = async () => {
    setIsGraveYardsLoading(true);
    await setNetworkTokens();
    setIsGraveYardsLoading(false);
  };

  // Load data once on mount and whenever the chain changes
  useEffect(() => {
    fetchData();
  }, [chainId]);

  const handleCloseSwapDialog = () => {
    setIsSwapDialogOpen(false);
  };

  const handleOpenSwapDialog = (_token) => {
    if (address) {
      setSelectedToken(_token);
      setIsSwapDialogOpen(true);
    } else {
      openConnectModal();
    }
  };

  const snackMessage = (message, variant) => {
    enqueueSnackbar(message, { variant });
    setTimeout(() => {
      closeSnackbar();
    }, 5000);
  };

  return (
    <div className="markets home-2">
      <section className="coin-list">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="flat-tabs1">
                <div className="content-tab1">
                  <div className="content-inner">
                    <div className="flat-tabs2">
                      <ul className="menu-tab2">
                        {networkList &&
                          chains
                            .sort((x) => x.id === chainId)
                            .map((x) => {
                              let _icon = '';
                              if (x.name === 'Ethereum') {
                                _icon = ethereumLogo;
                              } else if (x.name.includes('Avalanche')) {
                                _icon = avalancheLogo;
                              } else if (x.name.includes('Base')) {
                                _icon = baseLogo;
                              } else if (x.name === 'BNB Smart Chain') {
                                _icon = bscLogo;
                              } else if (x.name === 'Solana') {
                                _icon = solanaLogo;
                              }
                              return { ...x, icon: _icon };
                            })
                            .map((x) => (
                              <li
                                disabled={!switchChain || x.id === chainId}
                                key={x.id}
                                style={{ cursor: 'pointer' }}
                                className={x.id === chainId ? 'active' : ''}
                                onClick={() => handleSwitchNetwork(x.id)}
                              >
                                <h6 className="fs-16">
                                  <img
                                    src={x.icon}
                                    alt="Avatar"
                                    style={{
                                      width: 20,
                                      height: 20,
                                      borderRadius: '50%',
                                      marginRight: 7,
                                    }}
                                  />
                                  {x.name === 'BNB Smart Chain'
                                    ? 'Binance Smart Chain'
                                    : x.name}{' '}
                                  {isLoading &&
                                    pendingChainId === x.id &&
                                    pendingChainId !== chainId &&
                                    '...'}
                                  &nbsp;&nbsp;
                                </h6>
                              </li>
                            ))}
                      </ul>

                      <div className="content-tab2" style={{ minHeight: '700px' }}>
                        <div className="content-inner">
                          <div className="coin-list__main">
                            <div className="flat-tabs">
                              <Tabs>
                                <TabList>
                                  <Tab onClick={() => setIsSwapDialogOpen(false)}>
                                    Swap
                                  </Tab>
                                  <Tab>Claim</Tab>
                                </TabList>
                                <TabPanel>
                                  {!isSwapDialogOpen ? (
                                    <div className="content-inner" style={{ marginTop: 0 }}>

                                      <table className="table">
                                        <thead>
                                          <tr>
                                            <th scope="col"></th>
                                            <th scope="col">#</th>
                                            <th scope="col">Token Name</th>
                                            <th scope="col">Symbol</th>
                                            <th scope="col">Exchange Rate </th>
                                            {address && chainId && (
                                              <th scope="col">OSCAR Remaining</th>
                                            )}
                                            <th scope="col">OSCAR Price </th>
                                            <th scope="col">Vesting Period</th>
                                            <th scope="col">Address</th>
                                            <th scope="col"></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {tokens
                                            .map((x) => {
                                              let _icon = '';
                                              if (x.network === 'Ethereum') {
                                                _icon = ethereumLogo;
                                              } else if (
                                                x.network.includes('Avalanche')
                                              ) {
                                                _icon = avalancheLogo;
                                              } else if (
                                                x.network == 'BNB Smart Chain'
                                              ) {
                                                _icon = bscLogo;
                                              }
                                              return { ...x, network_icon: _icon };
                                            })
                                            .map((idx, num) => (
                                              <tr key={idx}>
                                                <th scope="row">
                                                  <span className="icon-star"></span>
                                                </th>
                                                <td>{num + 1}</td>
                                                <td>
                                                  <a href={`${idx.explorer}address/${idx.address}`} target="_blank">
                                                    <img
                                                      src={idx.icon}
                                                      alt=""
                                                      style={{
                                                        width: 25,
                                                        height: 25,
                                                        borderRadius: '50%',
                                                      }}
                                                    />
                                                    <span>{idx.name}</span>
                                                    <span className="unit">
                                                      {idx.unit}
                                                    </span>
                                                  </a>
                                                </td>
                                                <td>  <a href={`${idx.explorer}address/${idx.address}`} target="_blank">{idx.symbol}</a></td>
                                                <td className="up">


                                                  <HtmlTooltip
                                                    title={
                                                      <React.Fragment>
                                                        <Typography color="inherit">&nbsp;1 {idx.symbol} = {idx.exchange_rate}$ &nbsp;</Typography>
                                                        <span>&nbsp;Market price: {idx.initial_price}&nbsp;</span> <br />
                                                        <span>&nbsp;GraveYard rate: 300%&nbsp;</span>
                                                      </React.Fragment>
                                                    }
                                                  >
                                                    <Button>{idx.display_price}$</Button>
                                                  </HtmlTooltip>
                                                </td>
                                                {/* <td className="up">
                                               
                                                3x Market Price  
                                                </td> */}
                                                {address && chainId && (
                                                  <td className="boild">
                                                    {idx.hasOwnProperty('graveYardMaxHope') ? idx.graveYardMaxHope : 'Fetching...'}
                                                  </td>
                                                )}
                                                <td className="boild">

                                                  1.00$
                                                </td>
                                                <td className="boild">
                                                  {idx.vesting_period}
                                                </td>

                                                <td className="boild">
                                                  <a
                                                    href={`${idx.explorer}address/${idx.address}`}
                                                    target="_blank"
                                                  >
                                                    {idx.address.slice(0, 4)}...
                                                    {idx.address.slice(
                                                      idx.address.length - 4,
                                                      idx.address.length
                                                    )}
                                                  </a>
                                                </td>

                                                <td>
                                                  <Link
                                                    onClick={() =>
                                                      handleOpenSwapDialog(idx)
                                                    }
                                                    to="#"
                                                    className="btn"
                                                    data-target="#exampleModalCenter"
                                                  >
                                                    &nbsp; Swap &nbsp;
                                                  </Link>
                                                </td>
                                              </tr>
                                            ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  ) : (
                                    <Swap
                                      token={selectedToken}
                                      cancel={handleCloseSwapDialog}
                                      address={address}
                                    />
                                  )}
                                </TabPanel>
                                <TabPanel>
                                  <ClaimForm address={address} />
                                </TabPanel>
                              </Tabs>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isGraveYardsLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default Vaults;
